import React from 'react'
import PageHeader from '../../components/PageHeader'
import { motion } from 'framer-motion';
import { aboutUsData } from '../../data/websiteData';
import { Grid, PageTitle, StyledGrid, StyledGrid2  } from '../../styles/GlobalTheme/GlobalStyledComponents';
import { Content, Items, Item, ItemIcon, ItemText } from './StyledComponents';

//Animation
import Fade from 'react-reveal/Fade';

const index = () => {
    return (
        <>
            <motion.div
                initial={{opacity: 0.5}}
                animate={{opacity: 1}}
                exit={{opacity: 0.5}}
            >
                <PageHeader title={aboutUsData.title} image={aboutUsData.headerImage}></PageHeader>
                <Grid mb="33">
                    <PageTitle mb="0">{aboutUsData.pageTitle}</PageTitle>
                </Grid>
                
                <Grid>
                    <Items>
                        {aboutUsData.list.map((item, index) => (
                        <Item key={index}>
                            <Fade left cascade duration={1500}>
                                <ItemIcon src={item.icon}></ItemIcon>
                            </Fade>
                            <Fade up cascade duration={1500}>
                                <ItemText>{item.text}</ItemText>    
                            </Fade>
                        </Item>
                        ))}
                    </Items>
                </Grid>
                <Grid mb="105" mt="100">
                    <Content>{aboutUsData.content}</Content>
                </Grid>
            </motion.div>
        </>
    )
}

export default index
